import {
  addToCart,
  backToTopButtonBackgroundColor,
  backToTopIconColor,
  backgroundColor,
  buttonStyle,
  comingSoonPrice,
  comingSoonStatus,
  customerServiceBackgroundColor,
  flashSaleBarStyle,
  floatingActionButtonStyle,
  imageSetting,
  link,
  linkImage,
  loadingImage,
  outlineStyle,
  primaryCallToActionButtonStyle,
  productDetailsPageTabBarStyle,
  remainingStockTextStyle,
  remindMe,
  saleNowPrice,
  saleNowStatus,
  salesNowCountDownTimer,
  secondaryCallToActionButtonStyle,
  soldOut,
  textColor,
  topLeaderBoardBanner,
} from './constant';

export const loadingAnimationFields = [
  [loadingImage, imageSetting],
  [loadingImage],
];

export const topLeadBoardBannerFields = [
  [topLeaderBoardBanner, link, imageSetting],
  [topLeaderBoardBanner, link],
  [topLeaderBoardBanner, link, linkImage],
];

export const productDetailPageTabBarStyleFields = [
  [productDetailsPageTabBarStyle, addToCart, backgroundColor],
  [productDetailsPageTabBarStyle, addToCart, textColor],
  [productDetailsPageTabBarStyle, soldOut, backgroundColor],
  [productDetailsPageTabBarStyle, soldOut, textColor],
  [productDetailsPageTabBarStyle, remindMe, backgroundColor],
  [productDetailsPageTabBarStyle, remindMe, textColor],
];

export const flashSaleBarStyleFields = [
  [flashSaleBarStyle, comingSoonStatus, backgroundColor],
  [flashSaleBarStyle, comingSoonStatus, textColor],
  [flashSaleBarStyle, comingSoonPrice, backgroundColor],
  [flashSaleBarStyle, comingSoonPrice, textColor],
  [flashSaleBarStyle, saleNowStatus, backgroundColor],
  [flashSaleBarStyle, saleNowStatus, textColor],
  [flashSaleBarStyle, salesNowCountDownTimer, backgroundColor],
  [flashSaleBarStyle, salesNowCountDownTimer, textColor],
  [flashSaleBarStyle, saleNowPrice, backgroundColor],
  [flashSaleBarStyle, saleNowPrice, textColor],
];

export const primaryCallToActionButtonFields = [
  [primaryCallToActionButtonStyle, buttonStyle, backgroundColor],
  [primaryCallToActionButtonStyle, buttonStyle, textColor],
];

export const secondaryCallToActionButtonFields = [
  [secondaryCallToActionButtonStyle, outlineStyle, backgroundColor],
  [secondaryCallToActionButtonStyle, outlineStyle, textColor],
];

export const floatingActionButtonFields = [
  [floatingActionButtonStyle, customerServiceBackgroundColor],
  [floatingActionButtonStyle, textColor],
  [floatingActionButtonStyle, backToTopButtonBackgroundColor],
  [floatingActionButtonStyle, backToTopIconColor],
];

export const remainingStockTextStyleFields = [[remainingStockTextStyle]];
